import { Platform } from '@angular/cdk/platform';
import { inject, Injectable } from '@angular/core';
import { Http } from '@skylab-angular-shared/core';
import { ConsoleLogger, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

type TelemetryDeviceInfoLog = {
    device: 'mobile' | 'desktop';
};

type TelemetryLogEvent = 'AppStart';

type TelemetryLog = {
    event: TelemetryLogEvent,
    eventData: TelemetryDeviceInfoLog
};

@Injectable({providedIn: 'root'})
export class TelemetryLoggerService {
    private static readonly Url = TaggedUrl.join('telemetry/events', [Tags.Api]);
    private readonly logger = new ConsoleLogger(this.constructor.name);
    private http = inject(Http) as HttpService;
    private platform = inject(Platform);

    public log(event: TelemetryLogEvent): void {
        try {
            const data = this.prepareDataToLog(event);
            if (!data) return;

            this.http.post(TelemetryLoggerService.Url, {
                ...data,
                data: JSON.stringify(data.eventData)
            });
        } catch (err) {
            this.logger.error(err);
        }
    }

    private prepareDataToLog(event: TelemetryLogEvent): TelemetryLog {
        switch (event) {
            case 'AppStart':
                const isMobile = this.platform.ANDROID || this.platform.IOS;
                return {
                    eventData: { device: isMobile ? 'mobile' : 'desktop' },
                    event: 'AppStart'
                };
        }
    }
}
